<script>
import { mapGetters } from 'vuex'
export default {
    //TODO hozzárendelt csomagok

    name: 'CreateCompany',

    data() {
        return {
            userSearch: null,
            selectedUser: null,
            addressSearch: null,
            selectedAddress: null,
            selectedHost: null,
            model: {
                name: null,
                address: null,
                registration_number: null,
                tax_number: null,
                services_customer: [],
                services_provider: [],
                users: [],
                addresses: [],
            },
        }
    },

    computed: mapGetters({
        services: 'services',
        users: 'users',
        addresses: 'addresses',
    }),

    mounted() {
        this.$store.dispatch('title', this.$t('COMPANIES.CREATE'))
        this.fetchAddreses()
        this.fetchUsers()
    },

    methods: {
        save() {
            this.$store.dispatch('companiesCreate', this.model).then(() => {
                this.$router.go(-1)
            })
        },

        changeCustomer(e, id) {
            if (e) {
                this.model.services_customer.push(id)
            } else {
                this.model.services_customer.splice(
                    this.model.services_customer.indexOf(id),
                    1
                )
            }
        },

        changeProvider(e, id) {
            if (e) {
                this.model.services_provider.push(id)
            } else {
                this.model.services_provider.splice(
                    this.model.services_provider.indexOf(id),
                    1
                )
            }
        },

        fetchUsers() {
            this.$store.dispatch('usersFetchList', {
                search: this.userSearch,
                nopaged: true,
            })
        },

        fetchAddreses() {
            this.$store.dispatch('addressFetchList', {
                search: this.addressSearch,
                nopaged: true,
            })
        },

        addAddress() {
            this.model.addresses.push(this.selectedAddress)
            this.selectedAddress = null
        },

        delAddress(model) {
            this.model.addresses.splice(
                this.model.addresses.findIndex((item) => model.id == item.id),
                1
            )
        },

        addUser() {
            this.model.users.push(this.selectedUser)
            this.selectedUser = null
        },

        delUser(model) {
            this.model.users.splice(
                this.model.users.findIndex((item) => model.id == item.id),
                1
            )
        },
    },
}
</script>

<template lang="pug">
acrm-panel
    acrm-heading(:level="4") {{ $t('BASE.BASEDATA')}}
    .row
        .col-24.col-md.col-xl-5
            acrm-input-line(v-model="model.name") {{ $t('COMPANIES.NAME') }}
        .col-24.col-md.col-xl-7
            acrm-input-line(v-model="model.address") {{ $t('COMPANIES.ADDRESS') }}
        .col-24.col-md.col-xl-4
            acrm-input-line(v-model="model.registration_number") {{ $t('COMPANIES.REGISTRATION_NUMBER') }}
        .col-24.col-md.col-xl-4
            acrm-input-line(v-model="model.tax_number") {{ $t('COMPANIES.TAX_NUMBER') }}

    acrm-heading(:level="4") {{ $t('COMPANIES.ASSIGN_SERVICES')}}
    div.mb-3(v-html="$t('COMPANIES.ASSIGN_SERVICES_HELP')")
    table.table.table-striped.table-hover()
        thead
            tr
                th
                    .row.no-gutters
                        .col-4 {{ $t('BASE.SERVICE') }}
                        .col-4.col-xl-3 {{ $t('BASE.CLIENT') }}
                        .col-4.col-xl-3 {{ $t('BASE.PROVIDER') }}
        tbody
            tr(v-for="service in services" :key="service.id")
                td
                    .row.no-gutters
                        .col-12.col-md-4 {{ service.translated }}
                        .col-6.col-md-4.col-xl-3
                            acrm-input-switch(@input="changeCustomer($event, service.id)")
                        .col-6.col-md-4.col-xl-3
                            acrm-input-switch(@input="changeProvider($event, service.id)")
                        .col-24.col-md &nbsp;

    acrm-heading(:level="4") {{ $t('COMPANIES.ASSIGN_USERS')}}
    div.mb-3 {{ $t('COMPANIES.ASSIGN_USERS_HELP') }}
    label {{ $t('COMPANIES.ADD_USER') }}
    .row.mb-4
        .col-24.col-sm.col-lg-12.col-xl-10
            acrm-multi-select.mb-3.mb-sm-0(
                :options="users.data"
                :multiple="false"
                track-by="id"
                option-label="display_name"
                @search="userSearch = $event; fetchUsers()"
                v-model="selectedUser"
                :placeholder="$t('COMPANIES.ADD_USER_HINT')"
                )
        .col-24.col-sm-auto
            acrm-input-button(:disabled="selectedUser == null" block icon="add" @click="addUser") {{ $t('BASE.ADD') }}
    tempalte(v-if="model.users[0]")
        label {{ $t('COMPANIES.ADDED_USERS') }}
        table.table.table-striped.table-hover
            thead
                tr
                    th {{ $t('USERS.NAME') }}
                    th {{ $t('USERS.EMAIL') }}
                    th {{ $t('USERS.BALANCE') }}
                    th {{ $t('USERS.TYPE') }}
                    th &nbsp;
            tbody
                tr(v-for="user in model.users" :key="user.id")
                    td {{ user.display_name }}
                    td {{ user.email }}
                    td {{ user.balance }}
                    td {{ user.type }}
                    td
                        acrm-input-button.d-flex.float-right.btn-lg.p-0(variant="link" icon="close" @click="delUser(user)")

    acrm-heading(:level="4") {{ $t('COMPANIES.ASSIGN_ADDRESSES')}}
    div.mb-3 {{ $t('COMPANIES.ASSIGN_ADDRESSES_HELP') }}
    label {{ $t('COMPANIES.ADD_ADDRESS') }}
    .row.mb-4
        .col-24.col-sm.col-lg-20.col-xl-20
            acrm-multi-select.mb-3.mb-sm-0(
                :options="addresses.data"
                :multiple="false"
                track-by="id"
                option-label="address"
                @search="addressSearch = $event; fetchAddresses()"
                v-model="selectedAddress"
                :placeholder="$t('COMPANIES.ADD_ADDRESS_HINT')"
                )
        .col-24.col-sm-auto
            acrm-input-button(:disabled="selectedAddress == null" block icon="add" @click="addAddress") {{ $t('BASE.ADD') }}
    tempalte(v-if="model.addresses[0]")
        label {{ $t('COMPANIES.ADDED_ADDRESSES') }}
        table.table.table-striped.table-hover
            thead
                tr
                    th {{ $t('ADDRESSES.ADDRESS') }}
                    th {{ $t('ADDRESSES.HOST') }}
                    th &nbsp;
            tbody
                tr(v-for="address in model.addresses" :key="address.id")
                    td {{ address.address }}
                    td {{ address.host_user }}
                    td
                        acrm-input-button.d-flex.float-right.btn-lg.p-0(variant="link" icon="close" @click="delAddress(address)")

    hr
    .row
        .col-12.col-md-auto.ml-auto
            acrm-input-button.block-md-down(variant="light" @click="$router.go(-1)") {{ $t('BASE.BACK')}}
        .col-12.col-md-auto
            acrm-input-button.block-md-down(variant="success" @click="save") {{ $t('BASE.CREATE')}}


</template>
